var $ = require('./scaffold');
var math = require('./math');
var rootDoc = require('./');

var myChart = null;
var myChart2 = null;
module.exports = window.calc = function(isOutput) {
	if (!openTab.isLoaded) {
		openTab.onload = calc;
		return;
	}
	console.log('Recalculating...');

	// Read from the UI.
	for (var e in currentFields) {
		var t = $.get(e);
		if (t) {
			if (t.type === 'checkbox') currentValues[e] = $.get(e).checked;
			else currentValues[e] = $.get(e).value;
		}
	}

	var xLabels = [];

	var gridPowerCost = [];
	var gridCost = [];
	var pvPowerCost = [];
	var pvCost = [];

	// Calculate all the core stuff.
	try {
		var res = math.eval(equations, currentValues);
	} catch(e) {
		return;
	}

	dataTable.innerHTML = '';
	dataTable.appendChild($.create('tr', {children: [
		$.create('td', {innerText: 'Year: 0', style: 'font-size: 18px; color: red;'})
	]}));
	tablize(dataTable, equations.split('\n'), res.entries);

	// Calculate each year within the project lifespan
	for (var i=1; i<=currentValues.projectLife; i++) {
		res = math.eval(yearlyEquations, currentValues);

		dataTable.appendChild($.create('tr', {children: [
			$.create('td', {innerText: 'Year: '+i, style: 'font-size: 18px; color: red;'})
		]}));
		tablize(dataTable, yearlyEquations.split('\n'), res.entries);

		xLabels.push("Year "+i);
		gridCost.push(currentValues.gridCostAccumulatedNPV);
		pvCost.push(currentValues.PVCostAccumulatedNPV);
		gridPowerCost.push(currentValues.kWhAccumulatedGridCost);//gridCostAccumulatedNPV
		pvPowerCost.push(currentValues.kWhAccumulatedPVCost);
	}

	for (var e in currentFields) {
		if (currentValues[e] !== undefined) {
			var t = $.get(e);
			var cv = currentValues[e];
			if (!isNaN(cv) && cv !== '') cv = Math.round(cv*1000)/1000;
			if (t.tagName === 'INPUT' || t.tagName === 'SELECT') {
				$.get(e).value = cv;
			} else {
				//console.log(rootDoc.defaultData);
				if (rootDoc.defaultData[e] !== undefined) {
					if (!isNaN(cv)) {
						cv = cv/1;
						cv = cv.toFixed(rootDoc.defaultData[e]/1);
					}
				}
				$.get(e).innerText = cv;
			}
		}
	}

	if (isOutput) {
		setTimeout(function() {
			if (myChart) {
				myChart.destroy();
			}
			myChart = new Chart($.get('chartHolder'), {
				type: 'line',
				data: {
					xAxisID: 'Year in Analysis',
					yAxisID: 'Cost',
					labels: xLabels,
					datasets: [{
						label: 'kWh Accumulated Grid Cost',
						data: gridPowerCost,
						backgroundColor : "rgba(0,0,0,0)",
						borderColor : "rgba(128,64,96,1)"
					},{
						label: 'kWh Accumulated PV Cost',
						data: pvPowerCost,
						backgroundColor : "rgba(0,0,0,0)",
						borderColor : "rgba(64,128,96,1)"
					}]
				},
				options: {
					scales: {
						yAxes: [{
							scaleLabel: {
								display: true,
								labelString: 'Cost ($) Per kWh'
							}
						}]
					}
				}
			});
			if (myChart2) {
				myChart2.destroy();
			}
			myChart2 = new Chart($.get('chartHolder2'), {
				type: 'line',
				data: {
					xAxisID: 'Year in Analysis',
					yAxisID: 'Cost',
					labels: xLabels,
					datasets: [{
						label: 'Accumulated Grid Cost',
						data: gridCost,
						backgroundColor : "rgba(0,0,0,0)",
						borderColor : "rgba(128,64,96,1)"
					},{
						label: 'Accumulated PV Cost',
						data: pvCost,
						backgroundColor : "rgba(0,0,0,0)",
						borderColor : "rgba(64,128,96,1)"
					}]
				},
				options: {
					scales: {
						yAxes: [{
							scaleLabel: {
								display: true,
								labelString: 'Project Cost ($)'
							}
						}]
					}
				}
			});
		},1000);
	}
}

/* This is for debugging our equations. Press ~.*/

var dataVisible = false;
let dataOverlay = $.create('div', {
	style: 'position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; background: rgba(0,0,0,0.8); overflow: auto; z-index: 150;'
});
var dataTable = null;
dataTable = $.create('table', {parent: dataOverlay, style: 'color: white; border-spacing: 10px; border-collapse: separate;'});
$.on(window, 'keydown', function(e) {
	if (e.keyCode === 192) {
		if (dataVisible) document.body.removeChild(dataOverlay);				
		else document.body.appendChild(dataOverlay);
		dataVisible = !dataVisible;
	}
});
function tablize(table, eq, res) {
	var rn = 0;
	for (var equation of eq) {
		var row = $.create('tr', {
			parent: table,
			children: [
				$.create('td', {innerText: equation, style: 'max-width: 500px; overflow: hidden;'})
			]
		});
		if (equation !== '' && equation[0] !== '#') {
			row.appendChild($.create('td', {innerText: res[rn]}));
			rn++;
		} else {
			row.style.color = 'rgb(128,128,128)';
		}
	}
}
